import Chronotracklogo2 from '../assets/images/Chronotrack-logo2.png';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { BASE_PATH } from 'config';
const Logo = () => {

  return (
    <Link to={BASE_PATH} style={{ color: '#000', textDecoration: 'none' }}>
      <Typography variant="h6" fontWeight="bold" mt={2} sx={{ textDecoration: 'none' }}>
        Chronotrack
      </Typography>
    </Link>
    // <h1>ChronoTrack</h1>
    // <img src={Chronotracklogo2} alt="ChronoTrack" style={{ width: '200px', height: 'auto' }} />
  );
};

export default Logo;
